module.exports = __webpack_public_path__ + "static/cv-0646e9060f05895ff7c05b0a1ec1f034.pdf";